export const HTTP_CODE = {
  OFF_SERVER: 503,
  OKEY: 200,
};
